import React from 'react'
import { Helmet } from 'react-helmet'

const SeoTechSupport = ({ title, description }) => {
  return (
    <Helmet>
      <title>{title + ' | Gemvision'}</title>
      <meta name='description' content={description} />
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
      <link rel='canonical' href='https://gemvision.com/tech-support' />
      <script type='application/ld+json'>
        {`{
          "@context": "https://schema.org/", 
          "@type": "BreadcrumbList", 
          "itemListElement": [{
            "@type": "ListItem", 
            "position": 1, 
            "name": "Contact our Teams",
            "description": "Check the information of our offices (United States and International) to contact us.",
            "item": "https://gemvision.com/tech-support"  
          }]
        }`}
      </script>
    </Helmet>
  )
}

export default SeoTechSupport
